import type { RouteObject } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/category/:slug',
        lazy: () => import('@/pages/category/page').then((m) => ({ element: <m.default /> })),
      },
      {
        path: '/article/:slug',
        lazy: () => import('@/pages/article/page').then((m) => ({ element: <m.default /> })),
      },
      {
        path: '/about',
        lazy: () => import('@/pages/about/page').then((m) => ({ element: <m.default /> })),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;